const C = {
  name: "Gym",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 9C2 7.34315 3.34315 6 5 6H6C7.65685 6 9 7.34315 9 9V11H15V9C15 7.34315 16.3431 6 18 6H19C20.6569 6 22 7.34315 22 9V15C22 16.6569 20.6569 18 19 18H18C16.3431 18 15 16.6569 15 15V13H9V15C9 16.6569 7.65685 18 6 18H5C3.34315 18 2 16.6569 2 15V9ZM7 9C7 8.44772 6.55228 8 6 8H5C4.44772 8 4 8.44772 4 9V15C4 15.5523 4.44772 16 5 16H6C6.55228 16 7 15.5523 7 15V9ZM17 15C17 15.5523 17.4477 16 18 16H19C19.5523 16 20 15.5523 20 15V9C20 8.44772 19.5523 8 19 8H18C17.4477 8 17 8.44772 17 9V15Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Gym
};
